import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { redirectURL } from '../../redux/actions/navigationAction';

class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: props.isError || false };
  }

  componentDidUpdate(nextProps) {
    if (this.props.isError !== nextProps.isError) {
      this.setState(() => {
        return { hasError: true };
      });
    }
  }

  componentDidCatch() {
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      const {
        content: {
          errorPage: {
            title,
            description,
            optionsText,
            downloadPrintComplete,
            transferFormLink,
            cashISATransferFormLink,
            addressPaperForm,
            visitStoreText,
            callText,
            doneButtonText
          }
        },
        redirectURL
      } = this.props;

      return (
        <>
          <PageHeading>{title}</PageHeading>
          <StandardBody>{description}</StandardBody>
          <StandardBody isFlush>{optionsText}</StandardBody>
          <BulletList
            items={[
              <>
                {downloadPrintComplete}
                <a href={transferFormLink} target="_blank" rel="noopener noreferrer">
                  {cashISATransferFormLink}
                </a>
                {addressPaperForm}
              </>,
              visitStoreText,
              callText
            ]}
          />
          <NavigationButton.Primary label={doneButtonText} onClick={redirectURL} />
        </>
      );
    }
    return this.props.children;
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      redirectURL
    },
    dispatch
  );

const mapStateToProps = state => {
  return {
    content: state.content
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorPage);
